import * as React from "react";
import type { SVGProps } from "react";

const SvgEnvelopeOpen = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.753"
        height="20.207"
        viewBox="0 0 23.753 20.207"
        {...props}
    >
        <path
            id="Union_44"
            data-name="Union 44"
            d="M3,20.207a2.987,2.987,0,0,1-3-2.97V7.45A2.957,2.957,0,0,1,1.663,4.792l9.26-4.57a2.155,2.155,0,0,1,1.9,0L22.09,4.793a2.952,2.952,0,0,1,1.663,2.654v9.79a2.987,2.987,0,0,1-3,2.97Zm-1.3-2.97A1.288,1.288,0,0,0,3,18.511H20.756a1.288,1.288,0,0,0,1.3-1.273V7.591l-6.117,4.632,3.95,3.073a.848.848,0,1,1-1.041,1.338L11.994,11.3a.424.424,0,0,0-.52,0L4.621,16.634A.848.848,0,1,1,3.579,15.3l3.958-3.078L1.7,7.805ZM13.036,9.966l1.516,1.179,6.541-4.953L12.076,1.743a.467.467,0,0,0-.4,0L2.488,6.277,8.924,11.14l1.509-1.174a2.117,2.117,0,0,1,2.6,0Z"
            fill="currentColor"
        />
    </svg>
);
export default SvgEnvelopeOpen;
